import PhoneInput from "react-phone-number-input";
import "./phone-input.scss";
import React from "react";
import { FormControl } from "react-bootstrap";
import "react-phone-number-input/style.css";

export const PhoneNumberInput = props => {
  const { onNumberChange, onCountryChange, nationalNumber = "", countryCode = "US" } = props;

  return (
    <PhoneInput
      flagUrl={"https://media.redcircle.com/assets/flags/3x2/{XX}.svg"}
      defaultCountry={countryCode}
      value={nationalNumber}
      placeholder={"555-754-3010"}
      onChange={onNumberChange}
      onCountryChange={code => onCountryChange(code)}
      inputComponent={FormControlWithRef}
    />
  );
};

/*
  Helper component for Redux Form Fields
 */
export const PhoneNumberInputComponent = props => {
  const { phoneNumber, phoneNumberCountryCode } = props;
  const phoneNumberInput = phoneNumber.input;
  const countryCodeInput = phoneNumberCountryCode.input;
  return (
    <PhoneNumberInput
      onNumberChange={phoneNumberInput.onChange}
      onCountryChange={countryCodeInput.onChange}
      nationalNumber={phoneNumberInput.value}
      countryCode={countryCodeInput.value}
    />
  );
};

const FormControlWithRef = React.forwardRef((props, ref) => {
  const onChange = e => props.onChange(e.target.value);
  return (
    <FormControl
      {...props}
      inputRef={inputRef => ref && (ref.current = inputRef)}
      onChange={onChange}
    />
  );
});
